import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";

export const PlanPricesEditor = () => {
  const [plans, setPlans] = useState(null);
  const [vals, setVals] = useState({});
  const [busy, setBusy] = useState(false);
  const load = (list) => { setPlans(list); setVals(Object.fromEntries(list.map((p) => [p.id, String(p.amount)]))); };
  useEffect(() => { api.get("/billing/plans").then((r) => load(r.data)).catch((e) => toast.error(formatApiError(e))); }, []);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/plans", { amounts: Object.fromEntries(Object.entries(vals).map(([k, v]) => [k, Number(v)])) });
      load(data);
      toast.success("Plan prices saved and updated in Stripe");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  if (!plans) return <div className="loader-bar" />;
  return (
    <div className="space-y-5" data-testid="plan-prices-editor">
      <p className="text-sm text-slate-400 max-w-2xl">Prices in AUD. Saving updates the Subscribe page, the cover page and Stripe checkout straight away. Passes already bought are not changed.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {plans.map((p) => (
          <label key={p.id} className="panel p-4 flex flex-col gap-2">
            <span className="eyebrow">{p.label.includes("days") ? p.label : `${p.label} • ${p.days} days`}</span>
            <span className="flex items-center gap-1 text-lg text-white">$
              <input type="number" min={1} max={10000} step="0.01" value={vals[p.id] ?? ""} data-testid={`plan-price-input-${p.id}`}
                onChange={(e) => setVals({ ...vals, [p.id]: e.target.value })}
                className="w-28 bg-[#0F172A] border border-slate-700 rounded px-2 py-1 num focus:border-emerald-500 outline-none" />
            </span>
          </label>
        ))}
      </div>
      <Button onClick={save} disabled={busy} data-testid="plan-prices-save"><Save className="h-4 w-4 mr-1.5" />{busy ? "Saving..." : "Save prices"}</Button>
    </div>
  );
};
